module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.overlay),
      expression: "overlay"
    }],
    staticClass: "overlay",
    attrs: {
      "data-toggle": "sidemenu",
      "aria-controls": "sidemenu"
    },
    on: {
      "click": _vm.closeMenu
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.syncOverlay),
      expression: "syncOverlay"
    }],
    staticClass: "loading-overlay"
  }, [_c('div', {
    staticClass: "counter text-center"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("Trin " + _vm._s(_vm.activeStep) + " ud af " + _vm._s(_vm.totalSteps))]), _vm._v(" "), (_vm.errorMessage.length > 0) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()])]), _vm._v(" "), _c('header', {
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "left",
    attrs: {
      "data-toggle": "sidemenu",
      "aria-controls": "sidemenu"
    },
    on: {
      "click": _vm.showMenu
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("menu")]), _vm._v(" "), (_vm.notification > 0) ? _c('p', {
    staticClass: "small-icon notification"
  }, [_vm._v("!")]) : _vm._e()]), _vm._v(" "), _c('h1', [_vm._v("Opgaver")]), _vm._v(" "), _c('div', {
    staticClass: "right",
    on: {
      "click": _vm.gotoMap
    }
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 533.333 533.333"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "id": "Capa_1",
      "x": "0px",
      "y": "0px",
      "width": "20px",
      "height": "20px",
      "viewBox": "0 0 533.333 533.333",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M455.229,78.105c50.367,50.367,78.104,117.333,78.104,188.563c0,71.229-27.739,138.194-78.104,188.561   c-50.368,50.366-117.333,78.104-188.562,78.104c-71.229,0-138.195-27.738-188.562-78.104C27.738,404.862,0,337.896,0,266.668   c0-71.229,27.736-138.196,78.104-188.563S195.438,0,266.667,0C337.896,0,404.861,27.738,455.229,78.105z M431.658,431.659   c32.843-32.843,54.681-73.754,63.686-118.262c-7.019,10.331-13.732,14.165-17.888-8.961c-4.281-37.703-38.911-13.618-60.688-27.011   c-22.919,15.447-74.43-30.032-65.676,21.263c13.507,23.137,72.921-30.964,43.307,17.99   c-18.893,34.176-69.085,109.86-62.555,149.093c0.823,57.158-58.404,11.919-78.81-7.041   c-13.727-37.979-4.678-104.362-40.572-122.962c-38.959-1.691-72.398-5.232-87.497-48.786c-9.086-31.161,9.669-77.549,43.062-84.71   c48.88-30.711,66.341,35.965,112.183,37.205c14.233-14.893,53.029-19.628,56.246-36.328c-30.078-5.308,38.16-25.291-2.879-36.657   c-22.642,2.663-37.229,23.476-25.193,41.124c-43.874,10.23-45.279-63.492-87.454-40.238c-1.072,36.765-68.865,11.919-23.456,4.464   c15.602-6.816-25.448-26.57-3.271-22.98c10.894-0.592,47.569-13.444,37.644-22.084c20.421-12.677,37.583,30.359,57.572-0.98   c14.431-24.097-6.052-28.546-24.141-16.332c-10.198-11.418,18.006-36.081,42.882-46.738c8.29-3.552,16.208-5.487,22.263-4.939   c12.531,14.475,35.703,16.982,36.916-1.741c-31.031-14.861-65.247-22.712-100.672-22.712c-50.845,0-99.203,16.158-139.223,46.036   c10.755,4.927,16.86,11.062,6.499,18.904c-8.05,23.987-40.713,56.186-69.387,51.627c-14.889,25.674-24.694,53.961-28.885,83.608   c24.016,7.946,29.554,23.672,24.394,28.932c-12.237,10.671-19.759,25.797-23.633,42.355c7.817,47.832,30.298,91.914,65.245,126.862   C145.746,475.729,204.34,500,266.667,500C328.992,500,387.587,475.729,431.658,431.659z",
      "fill": "#FFFFFF"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "sidemenu fast",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "sidemenu",
      "data-toggler": "",
      "data-animate": "slide-in-left slide-out-left"
    }
  }, [_c('div', {
    staticClass: "close-button",
    attrs: {
      "data-toggle": "sidemenu",
      "aria-controls": "sidemenu"
    },
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "active",
    attrs: {
      "id": "projekter"
    }
  }, [_c('a', {
    attrs: {
      "data-toggle": "sidemenu",
      "aria-controls": "sidemenu"
    },
    on: {
      "click": _vm.gotoProjects
    }
  }, [_vm._m(2), _vm._v("\n          Opgaver\n        ")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "kort"
    }
  }, [_c('a', {
    staticClass: "map-item",
    attrs: {
      "data-toggle": "sidemenu",
      "aria-controls": "sidemenu"
    },
    on: {
      "click": _vm.gotoMap
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 533.333 533.333"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "id": "Capa_1",
      "x": "0px",
      "y": "0px",
      "width": "20px",
      "height": "20px",
      "viewBox": "0 0 533.333 533.333",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M455.229,78.105c50.367,50.367,78.104,117.333,78.104,188.563c0,71.229-27.739,138.194-78.104,188.561   c-50.368,50.366-117.333,78.104-188.562,78.104c-71.229,0-138.195-27.738-188.562-78.104C27.738,404.862,0,337.896,0,266.668   c0-71.229,27.736-138.196,78.104-188.563S195.438,0,266.667,0C337.896,0,404.861,27.738,455.229,78.105z M431.658,431.659   c32.843-32.843,54.681-73.754,63.686-118.262c-7.019,10.331-13.732,14.165-17.888-8.961c-4.281-37.703-38.911-13.618-60.688-27.011   c-22.919,15.447-74.43-30.032-65.676,21.263c13.507,23.137,72.921-30.964,43.307,17.99   c-18.893,34.176-69.085,109.86-62.555,149.093c0.823,57.158-58.404,11.919-78.81-7.041   c-13.727-37.979-4.678-104.362-40.572-122.962c-38.959-1.691-72.398-5.232-87.497-48.786c-9.086-31.161,9.669-77.549,43.062-84.71   c48.88-30.711,66.341,35.965,112.183,37.205c14.233-14.893,53.029-19.628,56.246-36.328c-30.078-5.308,38.16-25.291-2.879-36.657   c-22.642,2.663-37.229,23.476-25.193,41.124c-43.874,10.23-45.279-63.492-87.454-40.238c-1.072,36.765-68.865,11.919-23.456,4.464   c15.602-6.816-25.448-26.57-3.271-22.98c10.894-0.592,47.569-13.444,37.644-22.084c20.421-12.677,37.583,30.359,57.572-0.98   c14.431-24.097-6.052-28.546-24.141-16.332c-10.198-11.418,18.006-36.081,42.882-46.738c8.29-3.552,16.208-5.487,22.263-4.939   c12.531,14.475,35.703,16.982,36.916-1.741c-31.031-14.861-65.247-22.712-100.672-22.712c-50.845,0-99.203,16.158-139.223,46.036   c10.755,4.927,16.86,11.062,6.499,18.904c-8.05,23.987-40.713,56.186-69.387,51.627c-14.889,25.674-24.694,53.961-28.885,83.608   c24.016,7.946,29.554,23.672,24.394,28.932c-12.237,10.671-19.759,25.797-23.633,42.355c7.817,47.832,30.298,91.914,65.245,126.862   C145.746,475.729,204.34,500,266.667,500C328.992,500,387.587,475.729,431.658,431.659z",
      "fill": "#FFFFFF"
    }
  })])])]), _vm._v("\n          Kort\n        ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "data-toggle": "sidemenu",
      "aria-controls": "sidemenu"
    },
    on: {
      "click": _vm.syncData
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("sync")]), _vm._v(" "), (_vm.notification > 0) ? _c('p', {
    staticClass: "notification"
  }, [_vm._v("!")]) : _vm._e()]), _vm._v("\n          Synkronisér\n        ")])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "data-open": "aboutModal",
      "data-toggle": "sidemenu",
      "aria-controls": "sidemenu"
    },
    on: {
      "click": _vm.gotoAbout
    }
  }, [_vm._m(4), _vm._v("\n          Om MålerTjek\n        ")])])])]), _vm._v(" "), (_vm.showModal) ? _c('help-modal', {
    on: {
      "close": function($event) {
        _vm.showModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "reveal",
    attrs: {
      "id": "aboutModal",
      "data-reveal": ""
    }
  }, [_c('div', {
    staticClass: "reveal-header special-text"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("./assets/image/logo.png"),
      "alt": "logo"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("V. " + _vm._s(_vm.version) + ", udgivet " + _vm._s(_vm.date))])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('img', {
    staticClass: "niras-logo",
    attrs: {
      "src": require("./assets/image/niraslogo.svg"),
      "alt": "Niras logo"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "reveal-footer"
  }, [_vm._m(6), _vm._v(" "), _c('img', {
    staticClass: "firm-logo",
    attrs: {
      "src": _vm.image
    }
  })]), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('main', {
    attrs: {
      "role": "main"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("Synkroniserer data"), _c('span', {
    staticClass: "loading-overview"
  }, [_c('span', [_vm._v(".")]), _c('span', [_vm._v(".")]), _c('span', [_vm._v(".")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-menu"
  }, [_c('h2', [_c('b', [_vm._v("Måler")]), _vm._v("tjek")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("assignment")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "./files/MålertjekVejledning.pdf",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("help")])]), _vm._v("\n          Hjælp\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("info")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reveal-body"
  }, [_c('h5', [_vm._v("MålerTjek™ - programmet, der rationaliserer kontrol og udskiftning af forbrugsmålere.")]), _vm._v(" "), _c('p', [_vm._v("NIRAS har udviklet et system, der rationaliserer arbejdsopgaver vedrørende kontrol og udskiftning af forbrugsmålere i forsyningssektoren. Programmet hedder MålerTjek, og med det fjerner du tidsrøvere og gør samtidig livet lettere for både forsyningernes montører og deres administration samt for borgerne. ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Har du brug for support til MålerTjek, kan du ringe på support-telefonen "), _c('b', [_vm._v("2857 5859")]), _vm._v(" eller sende en e-mail til "), _c('a', {
    attrs: {
      "href": "mailto:infosupport@niras.dk?Subject=MålerTjek",
      "target": "_top"
    }
  }, [_vm._v("infosupport@niras.dk")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close-button",
    attrs: {
      "data-close": "",
      "aria-label": "Close modal",
      "type": "button"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0912b874","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1005
// module chunks = 1